'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('ramda/src/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _templateObject = _taggedTemplateLiteral(['display:inline-flex;align-items:center;padding:0 15px;min-width:80px;cursor:pointer;box-sizing:border-box;color:', ';min-height:', ';*{transition:initial;}&:hover{background-color:', ';color:', ';*{color:', ';}}&:active{background-color:', ';color:', ';*{color:', ';}}', ';'], ['display:inline-flex;align-items:center;padding:0 15px;min-width:80px;cursor:pointer;box-sizing:border-box;color:', ';min-height:', ';*{transition:initial;}&:hover{background-color:', ';color:', ';*{color:', ';}}&:active{background-color:', ';color:', ';*{color:', ';}}', ';']),
    _templateObject2 = _taggedTemplateLiteral(['background-color:transparent;color:', ';*{color:', ';}'], ['background-color:transparent;color:', ';*{color:', ';}']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _mcsLiteTheme = require('mcs-lite-theme');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BaseComponent = function BaseComponent(_ref) {
  var component = _ref.component,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['component', 'children']);

  return React.createElement(component, (0, _omit3.default)(['active'])(otherProps), children);
};
BaseComponent.displayName = 'BaseComponent';
BaseComponent.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
  children: _propTypes2.default.node.isRequired
};
var MenuItem = (0, _styledComponents2.default)(BaseComponent)(_templateObject, function (props) {
  return props.theme.color.black;
}, function (props) {
  return props.theme.height.normal;
}, function (props) {
  return props.theme.color.primary;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return (0, _mcsLiteTheme.darken1)(props.theme.color.primary);
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.theme.color.white;
}, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject2, props.theme.color.primary, props.theme.color.primary);
});

MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  active: _propTypes2.default.bool
};
MenuItem.defaultProps = {
  component: 'div',
  active: false
};

exports.default = MenuItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Menu/MenuItem.js
// module id = 552
// module chunks = 4